import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, X, MessageSquare, ExternalLink } from 'lucide-react';
import defaultImage from '../../assets/services/Box Letters/Box-Letters.png';
import bookletter from '../../assets/services/Box Letters/3D Box Letters.png';
import channelletter from '../../assets/services/Box Letters/Channel Letter.png';
import glowletter from '../../assets/services/Box Letters/Back Glow Letter.jpg';
import steelletter from '../../assets/services/Box Letters/Steel Letter.jpg';
import acrylicletter from '../../assets/services/Box Letters/Acrylic Letters.jpg';
import gold from "../../assets/services/Box Letters/gold.jpg";
import rosegold from '../../assets/services/Box Letters/rose gold.jpg';
import acpboard from '../../assets/services/ACP  BOARD/ACP  BOARD.jpg';
import acpboard1 from '../../assets/services/ACP  BOARD/ACP  BOARD1.jpg';
import acpboard2 from '../../assets/services/ACP  BOARD/ACP  BOARD2.jpg';
import acpboard3 from '../../assets/services/ACP  BOARD/ACP  BOARD3.jpg';
import acpboard4 from '../../assets/services/ACP  BOARD/ACP  BOARD4.jpg';
import acpboard5 from '../../assets/services/ACP  BOARD/ACP  BOARD5.jpg';
import fabricboard from '../../assets/services/FABRIC Board/FABRIC Board.jpg';
import glow from '../../assets/services/Glow Sign Board/Glow Sign Board.jpg';
import neon from '../../assets/services/NEON SIGNAGE/NEON SIGNAGE.jpg';
import neon1 from '../../assets/services/NEON SIGNAGE/NEON SIGNAGE1.jpg';
import neon2 from '../../assets/services/NEON SIGNAGE/Neon Multi Color.jpg';
import running from '../../assets/services/RUNNING LED PANEL/RUNNING LED PANEL.jpg';
import running1 from '../../assets/services/RUNNING LED PANEL/RUNNING LED PANEL.jpg';
import running2 from '../../assets/services/RUNNING LED PANEL/RUNNING LED PANEL1.jpg';
import video from '../../assets/services/VIDEO PANEL/VIDEO PANEL.jpg';
import video1 from '../../assets/services/VIDEO PANEL/VIDEO PANEL1.jpg';

const servicesData = [
  {
    id: 1,
    name: 'Box Letters',
    shortDesc:
      'Premium dimensional letters with depth and lighting options. Perfect for corporate branding with elegant, long-lasting signage that creates stunning visual impact.',
    imageUrl: defaultImage,
    hasSubServices: true,
    subServices: [
      {
        name: '3D Box Letters',
        imageUrl: bookletter,
        description:
          'Premium 3D dimensional letters with depth and lighting options. Perfect for corporate branding with elegant, long-lasting signage that creates stunning visual impact.',
      },
      {
        name: 'Channel Letter',
        imageUrl: channelletter,
        description:
          'Front-lit or halo-lit channel letters for maximum visibility. Customizable with various colors, fonts, and sizes to match your brand identity.',
      },
      {
        name: 'Back Glow Letter',
        imageUrl: glowletter,
        description:
          'Elegant backlit letters with stunning halo effect. Creates a sophisticated look perfect for premium brand displays and modern storefronts.',
      },
      {
        name: 'Steel Letter',
        imageUrl: steelletter,
        description:
          'Durable stainless steel letters for premium look. Weather-resistant and long-lasting, ideal for outdoor signage and corporate buildings.',
      },
      {
        name: 'Acrylic Letters',
        imageUrl: acrylicletter,
        description:
          'Crystal clear acrylic lettering with precision cutting. Available in various colors and finishes, perfect for indoor and outdoor applications.',
      },

      {
        name: 'Gold Box Letter',
        imageUrl: gold,
        description:
          'Premium gold finish letters for luxurious branding. Elegant metallic appearance with customizable lighting options.',
      },
      {
        name: 'Rose Gold Box Letter',
        imageUrl: rosegold,
        description:
          'Stunning rose gold finish letters for sophisticated branding. Luxurious metallic tone with premium lighting effects.',
      },
    ],

  },
  {
    id: 2,
    name: 'ACP BOARD',
    shortDesc:
      'Premium Aluminum Composite Panel cladding for modern facades. Durable, weather-resistant, and professionally installed.',
    imageUrl: acpboard,
    hasSubServices: true,
    subServices: [
      {
        name: 'LED Box Letter',
        imageUrl: acpboard1,
        description: 'Premium ACP board cladding variation. Durable aluminum composite panel for modern facades.',
      },
      {
        name: 'Aluminium Channel Letter',
        imageUrl: acpboard2,
        description: 'Weather-resistant ACP signage solution with customizable finishes.',
      },
      {
        name: 'Acrylic Flat letter',
        imageUrl: acpboard3,
        description: 'High-quality aluminum composite panel for building exteriors and signage.',
      },
      {
        name: 'Side Glow Acrylic Letter',
        imageUrl: acpboard4,
        description: 'Professional ACP board installation with vibrant color options.',
      },
      {
        name: 'Acralic Box Letter',
        imageUrl: acpboard5,
        description: 'Versatile ACP panels suitable for indoor and outdoor applications.',
      },
    ],
    description:
      'Aluminum Composite Panel (ACP) boards offer premium cladding solutions for modern building facades. Durable, weather-resistant, and available in various colors and finishes.',
  },
  {
    id: 3,
    name: 'FABRIC Board',
    shortDesc:
      'Flexible fabric signage for indoor displays. Lightweight, easy to install with vibrant print quality.',
    imageUrl: fabricboard,
    hasSubServices: true,
    subServices: [
      {
        name: 'Fabric Board',
        imageUrl: fabricboard,
        description:
          'Flexible fabric signage for indoor displays. Lightweight, easy to install with vibrant print quality.',
      },
    ],
    description:
      'Lightweight fabric-faced lightboxes and tension fabric graphics for retail, exhibitions, and interiors. Swap graphics easily, choose custom sizes, and keep colours vibrant under even illumination.',
  },
  {
    id: 4,
    name: 'Glow Sign Board',
    shortDesc: 'Illuminated signage with soft glow effects. Eye-catching designs that ensure 24/7 visibility.',
    imageUrl: glow,
    hasSubServices: true,
    subServices: [
      {
        name: 'Glow Sign Board',
        imageUrl: glow,
        description:
          'Illuminated signage with soft glow effects. Eye-catching designs that ensure 24/7 visibility and brand recognition with elegant lighting solutions.',
      },
    ],
    description:
      'Illuminated signage with soft glow effects. Eye-catching designs that ensure 24/7 visibility and brand recognition with elegant lighting solutions.',
  },
  {
    id: 5,
    name: 'NEON SIGNAGE',
    shortDesc:
      'Vibrant neon and LED neon signage. Retro and modern designs that create atmospheric lighting.',
    imageUrl: neon,
    hasSubServices: true,
subServices: [
      {
        name: 'NEON Single Color',
        imageUrl: neon1,
        description: 'Vibrant LED neon signage variation. Modern design for atmospheric lighting effects.',
      },
      {
        name: 'Neon Multi Color',
        imageUrl: neon2,
        description: 'Vibrant multi-color LED neon signage variation. Dynamic designs for eye-catching atmospheric lighting effects.',
      },
    ],
    description:
      'Vibrant neon and LED neon signage. Retro and modern designs that create atmospheric lighting and attract attention with colorful, eye-catching displays.',
  },
  {
    id: 6,
    name: 'RUNNING LED PANEL',
    shortDesc:
      'High brightness programmable LED scrolling display boards with inbuilt WiFi. Available sizes: P10 to P2.5',
    imageUrl: running,
    hasSubServices: true,
subServices: [
      {
        name: 'Single Color Running LED',
        imageUrl: running1,
        description: 'High brightness programmable scrolling LED panel with WiFi control.',
      },
      {
        name: 'Multi Color Running LED',
        imageUrl: running2,
        description: 'High brightness programmable multi-color scrolling LED panel with WiFi control for dynamic displays.',
      },
    ],
    description:
      'High brightness programmable LED scrolling display boards with inbuilt WiFi, so you can easily update text from mobile/PC/laptop anytime. Waterproof & dust-resistant, suitable for indoor and outdoor use. Available sizes: P10 to P2.5',
  },
  {
    id: 7,
    name: 'VIDEO PANEL',
    shortDesc:
      'High-brightness programmable LED video panels with inbuilt WiFi. Available sizes: P10 to P2.5',
    imageUrl: video,
    hasSubServices: true,
    subServices: [
      {
        name: 'Video Panel',
        imageUrl: video1,
        description: 'High-brightness programmable LED video panels with inbuilt WiFi.',
      },
    ],
    description:
      'High-brightness programmable LED video panels with inbuilt WiFi, allowing easy content updates from mobile, PC, or laptop anytime. Waterproof and dust-resistant for indoor and outdoor use. Available sizes: P10 to P2.5',
  },
];

function useGridReveal() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.06, rootMargin: '0px 0px -6% 0px' }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return [ref, visible];
}

function useRowReveal() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return [ref, visible];
}

function ServiceCategoryRow({ service, index, total, onExplore }) {
  const [ref, visible] = useRowReveal();
  const imageOnRight = index % 2 === 1;
  const isSpotlight = index === 0;
  const optionCount = service.subServices?.length ?? 0;

  return (
    <article
      ref={ref}
      className={[
        'relative grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 xl:gap-14 items-center',
        index > 0 ? 'pt-16 md:pt-24 border-t border-white/[0.07]' : '',
      ].join(' ')}
      aria-labelledby={`service-cat-${service.id}`}
    >
      <div
        className={[
          'lg:col-span-7',
          imageOnRight ? 'lg:col-start-6 lg:row-start-1' : 'lg:col-start-1',
          visible ? 'animate-fade-up' : 'opacity-0',
        ].join(' ')}
        style={{ animationDelay: visible ? '60ms' : undefined }}
      >
        <button
          type="button"
          onClick={() => onExplore(service)}
          className={[
            'relative group w-full text-left overflow-hidden rounded-2xl md:rounded-3xl ring-1 ring-white/10 shadow-card-premium',
            'transition-shadow duration-500 hover:shadow-card-premium-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-amber/60',
            isSpotlight ? 'min-h-[240px] sm:min-h-[280px] lg:min-h-[360px]' : 'min-h-[220px] sm:min-h-[260px] lg:min-h-[320px]',
          ].join(' ')}
        >
          <img
            src={service.imageUrl}
            alt=""
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.04]"
          />
          <div
            className="absolute inset-0 bg-gradient-to-tr from-black/55 via-transparent to-transparent opacity-85 md:opacity-75 group-hover:opacity-95 transition-opacity"
            aria-hidden
          />
          
          {/* More Options Overlay - appears on hover with gradient text */}
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-all duration-500 flex items-center justify-center">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-orange via-brand-amber to-brand-yellow font-bold text-xl md:text-2xl lg:text-3xl tracking-wider transform scale-90 group-hover:scale-110 transition-all duration-300">
              More Options
            </span>
          </div>
          
          <span className="sr-only">Open {service.name} variants</span>
          <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between gap-3">
            <span className="inline-flex items-center rounded-full bg-black/55 backdrop-blur-md px-3 py-1.5 text-[11px] font-bold tracking-[0.2em] text-brand-yellow border border-white/10">
              {String(index + 1).padStart(2, '0')} / {String(total).padStart(2, '0')}
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-gradient-brand px-3 py-1.5 text-xs font-bold text-black shadow-lg group-hover:opacity-0 transition-opacity duration-300">
              View options
              <ArrowUpRight className="w-3.5 h-3.5" aria-hidden />
            </span>
          </div>
          {isSpotlight ? (
            <span className="absolute top-4 right-4 hidden sm:inline rounded-full bg-black/45 backdrop-blur-md px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-brand-amber border border-white/10">
              Signature line
            </span>
          ) : null}
        </button>
      </div>

      <div
        className={[
          'lg:col-span-5 flex flex-col justify-center',
          imageOnRight ? 'lg:col-start-1 lg:row-start-1' : 'lg:col-start-8',
          visible ? 'animate-fade-up' : 'opacity-0',
        ].join(' ')}
        style={{ animationDelay: visible ? '140ms' : undefined }}
      >
        <div className="w-12 h-1 rounded-full bg-gradient-brand mb-5" aria-hidden />
        <p className="text-brand-amber/90 text-xs font-semibold uppercase tracking-[0.2em] mb-3">Service category</p>
        <h2 id={`service-cat-${service.id}`} className="text-xl sm:text-2xl md:text-3xl font-bold text-white leading-snug mb-4">
          {service.name}
        </h2>
        <p className="text-gray-400 text-base leading-relaxed mb-4">{service.shortDesc}</p>
        {optionCount > 0 ? (
          <p className="text-gray-500 text-sm mb-8">
            <span className="text-brand-yellow font-semibold">{optionCount}</span>
            {optionCount === 1 ? ' build option' : ' build options'} in this family — open to compare finishes and lighting.
          </p>
        ) : (
          <p className="text-gray-500 text-sm mb-8">Tap the image to see details and next steps.</p>
        )}

        <div className="flex flex-col sm:flex-row flex-wrap gap-3">
          <button
            type="button"
            onClick={() => onExplore(service)}
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-brand px-5 py-3 text-sm font-bold text-black hover:opacity-95 transition-opacity shadow-md"
          >
            <ArrowUpRight className="w-4 h-4 shrink-0" />
            Variants &amp; specs
          </button>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-sm font-semibold text-white hover:border-brand-amber/40 hover:bg-brand-orange/10 transition-colors"
          >
            Enquire
          </Link>
        </div>
      </div>
    </article>
  );
}

function Services({ variant = 'default' }) {
  const isPage = variant === 'page';
  const [gridRef, gridVisible] = useGridReveal();
  const [selectedService, setSelectedService] = useState(null);

  const handleServiceClick = useCallback((service) => {
    setSelectedService(service);
  }, []);

  const closePopup = useCallback(() => {
    setSelectedService(null);
  }, []);

  return (
    <section
      className={[
        isPage ? 'pt-4 md:pt-8 pb-20 md:pb-32' : 'py-16 md:py-24 border-t border-white/5',
        'bg-surface relative',
      ].join(' ')}
    >
      {!isPage && (
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.35] bg-[radial-gradient(ellipse_80%_60%_at_50%_-10%,rgba(234,88,12,0.08),transparent_50%)]"
          aria-hidden
        />
      )}

      <div className="container mx-auto px-4 relative z-10">
        {isPage ? (
          <header className="text-center mb-12 md:mb-16 max-w-2xl mx-auto">
            <p className="text-brand-amber text-xs md:text-sm uppercase tracking-[0.22em] font-semibold mb-3">
              Fabrication catalogue
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight">
              Seven capability lines —{' '}
              <span className="text-gradient-brand">scroll like case studies</span>
            </h2>
            <p className="text-gray-500 text-sm md:text-base mt-4">
              Alternating layout on desktop; open any row to browse sub-types, sizes, and enquiry
              actions. Hover the photo for a slow zoom.
            </p>
          </header>
        ) : (
          <div className="text-center mb-12">
            <span className="text-brand-amber text-sm uppercase tracking-[0.18em] font-semibold">
              Complete branding services
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-3 mb-4">
              Our <span className="text-gradient-brand">services</span>
            </h2>
            <p className="text-gray-400 max-w-2xl mx-auto text-base">
              From traditional signage to modern digital displays, we provide end-to-end solutions
              for your business.
            </p>
          </div>
        )}

        {isPage ? (
          <div className="max-w-6xl mx-auto space-y-0">
            {servicesData.map((service, index) => (
              <ServiceCategoryRow
                key={service.id}
                service={service}
                index={index}
                total={servicesData.length}
                onExplore={handleServiceClick}
              />
            ))}
          </div>
        ) : (
          <div
            ref={gridRef}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6"
          >
            {servicesData.map((service, idx) => {
              const delayMs = gridVisible ? idx * 80 : 0;
              return (
                <div
                  key={service.id}
                  className={[
                    'group bg-surface-elevated rounded-2xl overflow-hidden',
                    'hover:bg-white/[0.04] transition-all duration-300',
                    'border border-white/10 hover:border-brand-amber/35',
                    'hover:shadow-[0_0_40px_-10px_rgba(234,88,12,0.35)]',
                    gridVisible ? 'animate-fade-up' : 'opacity-0',
                  ].join(' ')}
                  style={{ animationDelay: `${delayMs}ms` }}
                >
                  <div
                    className="relative h-48 overflow-hidden cursor-pointer"
                    onClick={() => handleServiceClick(service)}
                    role="presentation"
                  >
                    <img
                      src={service.imageUrl}
                      alt={service.name}
                      className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                    <div
                      className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                      aria-hidden
                    />
                    
                    {/* More Options Overlay - appears on hover with gradient text */}
                    <div className="absolute inset-0 bg-black/40 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-all duration-500 flex items-center justify-center">
                      <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-orange via-brand-amber to-brand-yellow font-bold text-base md:text-lg tracking-wider transform scale-90 group-hover:scale-110 transition-all duration-300">
                        More Options
                      </span>
                    </div>
                  </div>

                  <div className="p-5 relative">
                    <h3
                      className="text-white font-semibold text-lg mb-2 cursor-pointer hover:text-brand-yellow transition-colors duration-200"
                      onClick={() => handleServiceClick(service)}
                      onKeyDown={(e) => e.key === 'Enter' && handleServiceClick(service)}
                      role="button"
                      tabIndex={0}
                    >
                      {service.name}
                    </h3>
                    <p className="text-gray-400 text-sm line-clamp-2 leading-relaxed">
                      {service.shortDesc.substring(0, 80)}...
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {selectedService && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/75 backdrop-blur-md animate-fade-in"
          role="dialog"
          aria-modal="true"
          aria-labelledby="service-modal-title"
        >
          <button
            type="button"
            className="absolute inset-0 cursor-default w-full h-full border-0 bg-transparent"
            aria-label="Close dialog backdrop"
            onClick={closePopup}
          />
          <div className="relative w-full max-w-6xl max-h-[90vh] overflow-y-auto rounded-2xl md:rounded-3xl border border-white/10 bg-[#0f0f0f] shadow-card-premium-hover animate-modal-in">
            <div className="absolute inset-0 rounded-2xl md:rounded-3xl pointer-events-none opacity-40 bg-gradient-to-br from-brand-orange/10 via-transparent to-brand-yellow/5" aria-hidden />
            <div className="relative flex justify-between items-center p-5 md:p-6 border-b border-white/10 sticky top-0 bg-[#0f0f0f]/95 backdrop-blur-md z-10">
              <div>
                <p className="text-brand-amber text-xs font-semibold uppercase tracking-wider mb-1">
                  Service lineup
                </p>
                <h3 id="service-modal-title" className="text-xl md:text-2xl font-bold text-white">
                  {selectedService.name}
                </h3>
              </div>
              <button
                type="button"
                onClick={closePopup}
                className="rounded-full p-2 text-gray-400 hover:text-white hover:bg-white/10 transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="relative p-5 md:p-8">
              {selectedService.hasSubServices ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                  {selectedService.subServices.map((sub, idx) => (
                    <div
                      key={`${sub.name}-${idx}`}
                      className="group/sub flex flex-col h-full rounded-2xl border border-white/10 bg-black/40 p-4 hover:border-brand-amber/40 transition-all duration-300 hover:shadow-[0_20px_40px_-15px_rgba(234,88,12,0.25)] hover:-translate-y-0.5"
                      style={{ animationDelay: `${idx * 60}ms` }}
                    >
                      <div className="h-32 md:h-36 rounded-xl mb-3 bg-black/30 flex items-center justify-center p-2">
                        <img
                          src={sub.imageUrl}
                          alt={sub.name}
                          className="w-full h-full object-contain transition-transform duration-500 group-hover/sub:scale-105"
                          onError={(e) => {
                            e.target.src = defaultImage;
                          }}
                        />
                      </div>
                      <h5 className="text-white font-semibold mb-2 text-base leading-snug">{sub.name}</h5>
                      <p className="text-gray-400 text-xs line-clamp-3 mb-4 flex-grow">
                        {sub.description
                          ? `${sub.description.substring(0, 100)}...`
                          : 'Premium signage solution.'}
                      </p>
                      <div className="flex gap-2 mt-auto pt-1">
                        <Link
                          to="/contact"
                          className="flex-1 bg-gradient-brand text-black text-center py-2.5 px-3 rounded-xl font-bold text-xs md:text-sm transition hover:opacity-95 flex items-center justify-center gap-1 shadow-md"
                        >
                          <ExternalLink className="w-3.5 h-3.5" />
                          Contact
                        </Link>
                        <a
                          href={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER}?text=${encodeURIComponent("Hi, I'm interested in " + sub.name + " (" + selectedService.name + ")")}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 border border-emerald-500/50 text-emerald-400 hover:bg-emerald-500 hover:text-white text-center py-2.5 px-3 rounded-xl font-semibold text-xs md:text-sm transition flex items-center justify-center gap-1"
                        >
                          <MessageSquare className="w-3.5 h-3.5" />
                          WhatsApp
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  <div className="w-full h-64 md:h-80 rounded-2xl mb-6 ring-1 ring-white/10 bg-black/30 flex items-center justify-center p-4">
                    <img
                      src={selectedService.imageUrl}
                      alt={selectedService.name}
                      className="w-full h-full object-contain"
                      onError={(e) => {
                        e.target.src = defaultImage;
                      }}
                    />
                  </div>
                  <p className="text-gray-300 mb-6 leading-relaxed">
                    {selectedService.description || selectedService.shortDesc}
                  </p>
                  {(selectedService.name === 'RUNNING LED PANEL' ||
                    selectedService.name === 'VIDEO PANEL') && (
                    <div className="rounded-xl border border-brand-amber/20 bg-brand-orange/5 p-4 mb-6">
                      <p className="text-gray-300 text-sm">
                        <span className="text-brand-amber font-semibold">Available sizes:</span> P10
                        to P2.5
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Services;